import React from "react";
import '../Components/Hire.css';
import { FaLinkedin } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";
import { FaItchIo } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import NavHeader from '../Components/navHeader.js';
import Footer from '../Components/footer.js';

function Hire() {
    return(
        <>
        <NavHeader/>
        <div className="CenterContent">
            <h1>Hire me!</h1>
            <div className="BrianImage">
                <img src="/BrianTheDev.jpg" alt="Brian" height={200}/>
            </div>
            <div className="Socials">
                <ul>
                    <li><a href="https://www.linkedin.com/in/brian-the-dev/"><FaLinkedin/></a></li>
                    <li><a href="https://github.com/BrianTheDevGuy"><FaGithub/></a></li>
                    <li><a href="https://brianthedevguy.itch.io/"><FaItchIo/></a></li>
                    <li><a href="mailto:brianayala2050@gmail.com"><MdEmail/></a></li>
                </ul>
            </div>
        </div>
        <Footer/>
        </>
    );
}

export default Hire
